var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bootstrap-canvas bg-white"},[(_vm.dataSource.loading)?_c('form-constructor',{attrs:{"data-source":_vm.dataSource}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }